// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3YQe9","list":"styles_list__1oAl2"};